const routerMaintenance = [
  {
    path: "/atualizar-preco",
    name: "UpdatePrice",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "UpdatePrice" */ "@/views/maintenance/updatePrice/Dashboard.vue"
      ),
  },
  {
    path: "/atualizar-preco/importar",
    name: "UpdatePriceTable",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "UpdatePriceTable" */ "@/views/maintenance/updatePrice/ImportTable.vue"
      ),
  },
  {
    path: "/mudar-colecao",
    name: "ChangeCollection",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ChangeCollection" */ "@/views/maintenance/changeCollection/Dashboard.vue"
      ),
  },
  {
    path: "/bloquear-produto",
    name: "BlockProducts",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "BlockProducts" */ "@/views/Product/BlockProducts.vue"
      ),
  },
];

export default routerMaintenance;
